import React from 'react'
import styled from 'styled-components'
import { UserIcon, LockIcon, EyeIcon } from '@/components/icons'

const PADDING_PX = 14

export const Container = styled.div`
  font-family: "Whitney A", "Whitney B", -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Arial, sans-serif;
  width: 100%;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--ggBackground);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  &, * {
    box-sizing: border-box;
  }
`

export const StoreDialogue = styled.div<{ hide?: boolean }>`
  width: 100%;
  height: 60px;
  display: ${props => props.hide ? 'none' : 'flex'};
  flex-direction: column;
  margin-bottom: 10px;

`

export const Title = styled.div`
  height: 26px;
  margin-bottom: 4px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #FFF;
  text-align: center;
  display: block;
  cursor: pointer;
  line-height:26px;
`

export const StoreIcon = styled.img`
  cursor: pointer;
  max-height: 100%;
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`

export const StoreIconAmazon = styled.img`
  margin-top: 5px;
  cursor: pointer;
`

export const NewTitle = styled.span`
  font-weight: 800;
  color: #49E69B;
`

export const StoreLinks = styled.div`
  display: flex;
  flex-direction: row;
  height: 30px;
  justify-content: space-evenly;
`

export const Form = styled.form`
  max-width: 100%;
  width: 30rem;
  width: 360px;
  padding: 20px;
`

export const Logo = styled.img`
  width: 100%;
  margin: 0 auto;
  margin-bottom: 1rem;
  display: block;
`

;(Logo as any).defaultProps = {
  src: './static/img/gg-logo.png'
}

export const InputContainer = styled.div`
  position: relative;
  opacity: 0.8;
  margin-bottom: ${PADDING_PX}px;
`

export const InputIconContainer = styled.span<{ position?: string; hasError?: boolean; onClick?: React.MouseEventHandler }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${`${PADDING_PX * 3}px`};
  height: ${`${PADDING_PX * 3}px`};
  padding: ${`${PADDING_PX}px`};
  color: var(--ggInactiveColor);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  ${({ position }) => `${position || 'left'}: 0;`}
  ${({ hasError }) => hasError && `
    color: var(--ggErrorColor);
  `}

  svg {
    width: 100%;
    height: 100%;
  }

  ${({ onClick }) => onClick && `cursor: pointer;`}
`

interface IconProps {
  hasError?: boolean
  onClick?: React.MouseEventHandler
}

export const UserIconLeft = ({ hasError }: IconProps) => {
  return (
    <InputIconContainer
      position='left'
      hasError={hasError}
    >
      <UserIcon/>
    </InputIconContainer>
  )
}

export const PasswordIconLeft = ({ hasError }: IconProps) => {
  return (
    <InputIconContainer
      position='left'
      hasError={hasError}
    >
      <LockIcon/>
    </InputIconContainer>
  )
}

export const PasswordIconRight = ({ hasError, onClick }: IconProps) => {
  return (
    <InputIconContainer
      position='right'
      hasError={hasError}
      onClick={onClick}
    >
      <EyeIcon/>
    </InputIconContainer>
  )
}

export const Input = styled.input<{ hasError?: boolean }>`
  & {
    width: 100%;
    margin: 0;
    font-size: 0.9rem;
    font-family: "Whitney A", "Whitney B", -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 700;
    min-height: 3rem;
    line-height: 1;
    background: var(--ggLightBackground);
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #FFF;
    border: none;
    padding: ${`${PADDING_PX}px`};
    padding-left: ${`${PADDING_PX * 3}px`};
    appearance: none;
    border: 1px solid transparent;
    border-radius: 5px;

    &::placeholder {
      color: var(--ggInactiveColor);
    }

    &:focus {
      border: 1px solid var(--ggMainColor);
      transition: border-width 0.6s linear !important;
      outline: none;

      &&& ~ ${InputIconContainer} {
        color: var(--ggMainColor);
      }
    }

    && {
      ${({ hasError }) => hasError && `
        border-color: var(--ggErrorColor);
      `}

      & ~ ${InputIconContainer} {
        color: ${({ hasError }) => `var(${hasError ? '--ggErrorColor' : '--ggInactiveColor'});`};
      }
    }
  }
`

export const Button = styled.button<{ grey?: boolean }>`
  font-family: "Whitney A", "Whitney B", -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 700;
  letter-spacing:0.6px;
  font-size: 1.2rem;
  cursor: pointer;
  display: block;
  background-image: var(--ggButtonLinearGradient);
  border: none;
  transition: border-radius 0.5s ease, background-size 0.5s ease;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  margin-bottom: 1rem;
  font-size: 1.1rem;
  min-height: 3rem;
  line-height: 1;
  box-shadow: 0px 5px 15px rgba(var(--ggMainColorRGB), 0.6);
  border-radius: 5px;
  border: none;
  padding: 1rem;
  appearance: none;
  color: #FFF;
  background-size: 100% 100%;

  ${props => props.grey && `
    background-image: linear-gradient(to right, #cbcbcb, #e3e3e3);
  `}

  &:hover, &:focus {
    border-radius: 3rem;
    background-size: 200% 100%;
  }
`

export const ValidationError = styled.p`
  text-align: center;
  color: var(--ggErrorColor);
`
export const P = styled.p`
  font-weight: 500;
  color: #FFF;
  text-align: center;
  display: block;
`

export const Anchor = styled.a`
  flex: 1;
  font-weight: 500;
  color: var(--ggInactiveColor);
  text-align: center;
  display: block;
  cursor: pointer;
  line-height: 26px;
  text-decoration: underline;

  &:hover {
    color: var(--ggMainColor);
  }
`

export const SpeechBubble = styled.div`
  user-select: none;
  margin-top: 20px;
  color: #cccccc;
  font-family: "Whitney A", "Whitney B", -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Arial, sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .speech-title {
    font-size: 13px;
    color:#fff;
  }

  .speech-bubble {
    background: var(--ggLightBackground);
    color: var(--ggInactiveColor);
    font-size: 13px;
    line-height: 13px;
    padding: 10px;
    position: relative;
    border-radius: 5px;
    width: 100%;
  }

  a {
    color: var(--ggMainColor);
  }

  p {
    margin-bottom: 5px;
  }

  .speech-bubble p:last-of-type {
    margin-bottom: 0;
  }

`
